import { PROGRAM_OUTCOME_PILL } from '@/shared/utils/statusPills';

/**
 * How a course support request reads in one program's own list: the
 * program's own decision (`programOutcome` from the server), not the
 * request's shared status, which on a request two programs hold is the other
 * program's award as readily as this one's. Wording and colour come from the
 * shared pill map.
 */
export const PROGRAM_OUTCOME_ORDER = Object.keys(PROGRAM_OUTCOME_PILL);

export const PROGRAM_OUTCOME_OPTIONS = PROGRAM_OUTCOME_ORDER.map((value) => ({
    value,
    label: PROGRAM_OUTCOME_PILL[value].label,
}));
